import { render, staticRenderFns } from "./AddStartupsPreviewModal.vue?vue&type=template&id=2ec85797&scoped=true&"
import script from "./AddStartupsPreviewModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./AddStartupsPreviewModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AddStartupsPreviewModal.vue?vue&type=style&index=0&id=2ec85797&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec85797",
  null
  
)

export default component.exports